import { createSelector } from 'reselect'

const user = (state) => state.user

export const getUser = createSelector(
  [ user ],
  (user) => {
    return Object.assign(
      {},
      user,
      {
        fullname: user.name+ " " + user.surname,
        pending: user.loggingIn || user.loggingOut || user.fetching
      }
    )
  }
)

export const getUserLoggedIn = createSelector(
  [ getUser ],
  (user) => {
    return user.loggedIn
  }
)



// WEBPACK FOOTER //
// ./src/app/react-redux/selectors/user.js